






























import { Mixins, Component, Provide } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import PageMixin from "@/mixins/page"
import { getColumns } from "./constant"
import policyService from "@/services/policy.service"
import { mapGetters } from "vuex"
@Component({
    name: "ContrastList",
    components: {
        PageHeader
    },
    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters("common", [
            "product_type",
            "product_sub_type",
            "corporation",
            "top_dept",
            "software_list",
            "privacy_policy_text_type",
            "area",
            "privacy_policy_status",
            "preparation_status",
            "privacy_policy_sync_way",
            "productSubTypeMap",
            "areaMap",
            "preparationStatusMap",
            "PolicyStatusMap",
            "textTypeMap"
        ])
    }
})
export default class ContrastList extends Mixins(PageMixin) {
    readonly software_list: any
    readonly privacy_policy_text_type: any
    readonly product_sub_type: any
    readonly area: any
    readonly privacy_policy_status: any
    readonly preparation_status: any
    readonly privacy_policy_sync_way: any
    readonly productSubTypeMap: any
    readonly areaMap: any
    readonly preparationStatusMap: any
    readonly PolicyStatusMap: any
    readonly textTypeMap: any
    loading = false
    tableData: any[] = []
    exportLoading = false
    pagination = {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showLessItems: true,
        size: "normal",
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "100"],
        get limit() {
            return this.pageSize
        },
        get offset() {
            return (this.current - 1) * this.pageSize
        },
        showTotal: (total: number) => `共${total}项`,
        onChange: function(this: any, page: number, pageSize: number) {
            this.pagination.pageSize = pageSize
            this.pagination.current = page
            this.onSearch(
                this.searchParams.keyword,
                { current: page, pageSize: pageSize },
                this.searchParams.sorts,
                this.searchParams.filters
            )
        }.bind(this),
        onShowSizeChange: function(this: any, current: number, size: number) {
            this.pagination.pageSize = size
            this.pagination.current = 1
            this.onSearch(
                this.searchParams.keyword,
                { current: 1, pageSize: size },
                this.searchParams.sorts,
                this.searchParams.filters
            )
        }.bind(this)
    }
    @Provide()
    get useWrapperContext() {
        return this
    }
    get softwareList() {
        return this.software_list.map((item: any) => {
            return {
                label: item.software_name,
                value: item.software_id
            }
        })
    }
    get columns() {
        return getColumns(this)
    }
    get tableActions() {
        return () => {
            const actions = {
                edit: {
                    title: "编辑",
                    event: "edit"
                },
                detail: {
                    title: "详情",
                    event: "detail"
                }
            }

            return Object.values(actions)
        }
    }
    searchParams = {
        keyword: "",
        pagination: { current: 1, pageSize: 10 },
        sorts: [] as any[],
        filters: [] as any[]
    }
    isActive = true
    activated() {
        this.isActive = true
        this.onSearch(
            this.searchParams.keyword,
            this.searchParams.pagination,
            this.searchParams.sorts,
            this.searchParams.filters
        )
    }

    deactivated() {
        this.isActive = false
    }

    createContrast() {
        this.$router.push({
            path: "/channel/contrast-edit"
        })
    }
    onDetail(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/channel/contrast-detail",
            query: {
                id: String(record.id)
            }
        })
    }

    onEdit(records: any[]) {
        const record = records[0]
        this.$router.push({
            path: "/channel/contrast-edit",
            query: {
                id: String(record.id)
            }
        })
    }
    async onSearch(
        keyword: string,
        pagination: any,
        sorts: any[],
        filters: any[]
    ): Promise<{ total: number; list: any[] }> {
        Object.assign(this.searchParams, { keyword, pagination, sorts, filters })

        // 如果传入了pagination参数，则使用传入的参数更新当前分页状态
        if (pagination) {
            this.pagination.current = pagination.current || this.pagination.current
            this.pagination.pageSize = pagination.pageSize || this.pagination.pageSize
        }

        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        const query: any = {}
        this.searchParams.filters.forEach(item => {
            if (item.dataIndex === "software_name") {
                query["software_id"] = item.keyword
            } else {
                query[item.dataIndex] = item.keyword
            }
        })

        const payload = {
            offset,
            limit,
            ...query
        }
        this.loading = true
        try {
            const res: any = await policyService.getComparePolicyList(payload)
            const { list, total } = res || {}
            this.tableData = list || []
            this.pagination.total = total
            return {
                list,
                total
            }
        } catch (error) {
            if (error) {
                this.$message.error(`获取数据失败！ ${error}`)
            }
        } finally {
            this.loading = false
        }
    }

    handleExport() {
        this.exportLoading = true
        const query: any = {}
        const offset = (this.pagination.current - 1) * this.pagination.pageSize
        const limit = this.pagination.pageSize
        this.searchParams.filters.forEach((item: any) => {
            if (item.dataIndex === "software_name") {
                query["software_id"] = item.keyword
            } else {
                query[item.dataIndex] = item.keyword
            }
        })

        const payload = {
            offset,
            limit,
            ...query
        }
        policyService
            .exportComparePolicy(payload)
            .catch(err => {
                this.$message.error(`${err}`)
            })
            .finally(() => {
                this.exportLoading = false
            })
    }
}
